import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { PricingWidget } from './PricingWidget'

class HoldstyringPricingElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return PricingWidget
  }

  // Supported HTML attributes:
  //   plan-ids="id1,id2,id3"   — restrict + order which plans render (otherwise all)
  //   show-features="false"    — hide the bullet feature list (default: visible)
  //   title="Vores priser"     — heading shown above the cards (default: the studio's own
  //                              pricing-page heading if it has set one, V516; else none)
  //   layout="cards|table|compact"  — visual layout (default: cards)
  //   classes-href="#schedule" — where "See classes" points (default: the studio's
  //                              booking page). Use an anchor on your OWN page so
  //                              browsing classes does not leave your site.
  //   button-text="Book"      — own label on the "See classes" button. Wins over the
  //                              text set under Admin → Widgets; empty = that text,
  //                              or the default in the studio's language (OPG-0064)
  //   category-filter="true"   — All / Drop-in / Punch card chips above the plans
  //                              (same switch as the studio's own pricing page;
  //                              hidden when there is only one category)
  protected getWidgetProps() {
    const planIdsRaw = this.getAttribute('plan-ids')
    const planIds = planIdsRaw
      ? planIdsRaw.split(',').map(s => s.trim()).filter(Boolean)
      : null
    const rawLayout = this.getAttribute('layout')
    const layout: 'cards' | 'table' | 'compact' =
      rawLayout === 'table' || rawLayout === 'compact' ? rawLayout : 'cards'
    return {
      planIds,
      showFeatures: this.getAttribute('show-features') !== 'false',
      title: this.getAttribute('title') || null,
      layout,
      categoryFilter: this.getAttribute('category-filter') === 'true',
      classesHref: this.getAttribute('classes-href') || null,
      buttonText: this.getAttribute('button-text') || null,
    }
  }
}

if (!customElements.get('holdstyring-pricing')) {
  customElements.define('holdstyring-pricing', HoldstyringPricingElement)
}

export { HoldstyringPricingElement }
